import { useQuery } from "@tanstack/react-query";
import { getDashboardEAFProduction } from "../../../repositories/ProductionRepository";
import type { EAFProcessByShift } from "../../../models/ProcessByShift";

export const useEAFProductionQuery = (
  startDate: Date | null,
  endDate: Date | null,
) => {
  return useQuery({
    queryKey: [
      "dashboard-eaf-production",
      startDate?.toISOString(),
      endDate?.toISOString(),
    ],
    meta: { realtime: ["RBD.GetDashboardEAFProduction"] },
    queryFn: async ({ signal }) => {
      const resp = await getDashboardEAFProduction(startDate, endDate, signal);
      if (resp.ok) {
        return (resp.data?.tables[0].rows as EAFProcessByShift[]) ?? [];
      }
      throw new Error(resp.message ?? "Failed to fetch EAF production");
    },
    enabled: !!startDate && !!endDate,
  });
};
